module.exports = __webpack_public_path__ + "static/media/alt-key.cba0b62b.svg";